export default {
      id: "icon-heart-usage",
      viewBox: "0 0 21 18",
      url: __webpack_public_path__ + "icons.svg#icon-heart",
      toString: function () {
        return this.url;
      }
    }